module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.4adc1b43.svg";